<template>
  <BoletinView fetch-path="settlement" toolbar-title="Liquidación" type-label="Tipo de liquidación"
               descripion-label="Observación" period></BoletinView>
</template>

<script>
import BoletinView from '../../boletines/views/BoletinView'

export default {
  components: {
    BoletinView
  }
}
</script>
